import $ from 'jquery';
import Viewport from './Viewport';
import '../vendor/dotimeout/jquery.ba-dotimeout.min';

const defaults = {
  hoverInit: 250,
  hoverDelay: 250,
  selector: 'li.menuparent',
};

function Menu(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.$menus = this.getMenus();
  this.over = $.proxy(this.over, this);
  this.out = $.proxy(this.out, this);
  this.listen();
}

Menu.prototype = {
  getMenus() {
    return this.$element.find(this.settings.selector);
  },
  over(event) {
    const $target = $(event.currentTarget);
    if (Viewport.currentState === 'large') {
      $target.doTimeout('hide');
      $target.doTimeout('show', this.settings.hoverInit, () => {
        $target.addClass('show');
      });
    }
  },
  out(event) {
    const $target = $(event.currentTarget);
    if (Viewport.currentState === 'large') {
      $target.doTimeout('show');
      $target.doTimeout('hide', this.settings.hoverDelay, () => {
        $target.removeClass('show');
      });
    }
  },
  listen() {
    this.$menus.removeClass('show').on('mouseover', this.over).on('mouseout', this.out);
  },
};

export default Menu;



// WEBPACK FOOTER //
// ./Menu.js